import { render, staticRenderFns } from "./DocumentRequeteCard.vue?vue&type=template&id=035d6e1a&scoped=true&"
import script from "./DocumentRequeteCard.vue?vue&type=script&lang=js&"
export * from "./DocumentRequeteCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRequeteCard.vue?vue&type=style&index=0&id=035d6e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d6e1a",
  null
  
)

export default component.exports